export default __webpack_public_path__ + "static/media/scanreview-placeholder.52a87822.png";